import { Component } from '@angular/core';
import { CoreIcon, ICON_TEMPLATE } from '@primeicons/angular/core';
import { blank } from '@primeicons/core/blank';

@Component({
    selector: 'svg[data-p-icon="blank"]',
    standalone: true,
    template: ICON_TEMPLATE
})
export class Blank extends CoreIcon {
    constructor() {
        super();
        this._icon = blank;
    }
}
